module.exports = __webpack_public_path__ + "img/enkrypt-logo.cc2d2661.png";